import type { JSX } from 'react';

import { ThemeProvider } from '@change/ds-core-ui';
import { InfoIcon } from '@change/ds-icons';

import { Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import { useMembershipModalState } from '../modalContext';

export function ValidationError(): JSX.Element | null {
	const [{ validationErrors }] = useMembershipModalState();
	if (!validationErrors || !validationErrors.amount) return null;
	return (
		<Flex data-qa="invalid-amount-error" sx={{ alignItems: 'center' }}>
			<ThemeProvider>
				<div className="flex items-center">
					<InfoIcon className="text-typography-information" />
				</div>
			</ThemeProvider>
			<Text
				sx={{
					paddingLeft: '16px',
					fontSize: '14px',
					fontWeight: 'normal',
					color: 'sunrise.semantic.typography.information',
				}}
			>
				{validationErrors.amount}
			</Text>
		</Flex>
	);
}
